// extracted by mini-css-extract-plugin
export default {"status":"Status_status_nvWTb"};